import React from "react";

function createPoint(x = 0, y = 0) {
  return {
    id: `pt_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    x,
    y,
  };
}

function normalizePoints(points = []) {
  return points.map((p) => ({
    id: p.id || `pt_${Math.random().toString(36).slice(2, 8)}`,
    x: p.x ?? 0,
    y: p.y ?? 0,
  }));
}

export default function BoardPolygonInspector({
  profile,
  onChangeProfile,
  parameters,
  onChangeParameters,
}) {
  const safeProfile = profile || {
    type: "polygon",
    points: [
      createPoint(0, 0),
      createPoint(600, 0),
      createPoint(600, 720),
      createPoint(0, 720),
    ],
    cutouts: [],
  };

  const safeParams = parameters || {
    width: 600,
    height: 720,
    thickness: 18,
  };

  const points = normalizePoints(safeProfile.points || []);

  function patchProfile(nextPatch) {
    onChangeProfile?.({
      ...safeProfile,
      ...nextPatch,
    });
  }

  function patchPoint(pointId, field, value) {
    const nextPoints = points.map((pt) =>
  pt.id === pointId ? { ...pt, [field]: value } : pt
);

    patchProfile({ points: nextPoints });
  }

  function addPoint() {
    const last = points[points.length - 1] || { x: 0, y: 0 };
    patchProfile({
      points: [...points, createPoint(last.x + 100, last.y + 100)],
    });
  }

  function removePoint(pointId) {
    const nextPoints = points.filter((pt) => pt.id !== pointId);
    patchProfile({ points: nextPoints });
  }

  function movePoint(pointId, dir) {
    const index = points.findIndex((pt) => pt.id === pointId);
    if (index < 0) return;

    const next = [...points];
    const swapIndex = dir === "up" ? index - 1 : index + 1;

    if (swapIndex < 0 || swapIndex >= next.length) return;

    [next[index], next[swapIndex]] = [next[swapIndex], next[index]];
    patchProfile({ points: next });
  }

  function setRectPreset() {
    patchProfile({
      type: "polygon",
      points: [
        createPoint(0, 0),
        createPoint(Number(safeParams.width) || 600, 0),
        createPoint(Number(safeParams.width) || 600, Number(safeParams.height) || 720),
        createPoint(0, Number(safeParams.height) || 720),
      ],
      cutouts: safeProfile.cutouts || [],
    });
  }

  function patchParam(key, value) {
    onChangeParameters?.({
      ...safeParams,
      [key]: Number(value) || 0,
    });
  }

  return (
    <div className="p-3 space-y-4">
      <h3 className="font-semibold text-lg">Board Polygon</h3>

      <div>
        <label className="block text-sm font-medium mb-1">Thickness</label>
        <input
          type="number"
          value={safeParams.thickness ?? 18}
          onChange={(e) => patchParam("thickness", e.target.value)}
          className="w-full px-3 py-2 border rounded"
        />
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-sm font-medium mb-1">Ref Width</label>
          <input
            type="number"
            value={safeParams.width ?? 600}
            onChange={(e) => patchParam("width", e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Ref Height</label>
          <input
            type="number"
            value={safeParams.height ?? 720}
            onChange={(e) => patchParam("height", e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <button onClick={setRectPreset} className="px-3 py-2 rounded border">
          Rectangle Preset
        </button>
        <button
          onClick={addPoint}
          className="px-3 py-2 rounded bg-blue-600 text-white"
        >
          + Add Point
        </button>
      </div>

      <div className="space-y-3">
        {points.map((pt, index) => (
          <div key={pt.id} className="border rounded p-3 space-y-2">
            <div className="text-sm font-medium">Point {index + 1}</div>

            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-sm font-medium mb-1">X</label>
                <input
  type="text"
  value={pt.x ?? ""}
  onChange={(e) => patchPoint(pt.id, "x", e.target.value)}
  placeholder="width - 70"
/>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Y</label>
                <input
  type="text"
  value={pt.y ?? ""}
  onChange={(e) => patchPoint(pt.id, "y", e.target.value)}
  placeholder="height - 110"
/>
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => movePoint(pt.id, "up")}
                className="px-3 py-1 rounded border"
              >
                Up
              </button>
              <button
                onClick={() => movePoint(pt.id, "down")}
                className="px-3 py-1 rounded border"
              >
                Down
              </button>
              <button
                onClick={() => removePoint(pt.id)}
                className="px-3 py-1 rounded border text-red-600"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}